import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { UnlayerEmailsTabView } from '@/components/views/UnlayerEmailsView/UnlayerEmailsTabView';

export const UnlayerTemplatesPage = () => {
	return (
		<AuthenticatedPageLayout>
			<UnlayerEmailsTabView />
		</AuthenticatedPageLayout>
	);
};
